var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEditPlanePen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit",
    transform: "translate(-290 -87)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(290 87)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "so-pencil-ui-3",
    d: "M14.8,4.691a.683.683,0,0,1,0,.965L6.685,13.772,3,15l1.228-3.685L12.343,3.2a.683.683,0,0,1,.965,0Z",
    transform: "translate(296 93)",
    fill: "#f8f8f8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditPlanePen);
export default __webpack_public_path__ + "static/media/icon-edit-plane-pen.5f86f186af4ffb4c151e0f7233f42097.svg";
export { ForwardRef as ReactComponent };